import { createControlFn } from "../create-control-fn"

const controlDocumentNumberFieldFn = createControlFn({
  filterValueCb: (value) => !/[^a-zA-Z0-9]/.test(value),
  transformValueCb: (value) => value?.toUpperCase(),
})

export { controlDocumentNumberFieldFn }
